import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feature-members',
  templateUrl: './feature-members.component.html',
  styleUrls: ['./feature-members.component.css']
})
export class FeatureMembersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
